module.exports = __webpack_public_path__ + "img/thantai-trungthuong.199f8881.png";